import gql from 'graphql-tag';

const GET_USER_CLAIM_INVESTMENT_DETAILS = gql`
    query getUserClaimInvestmentDetails ( $poolId: String! ) {
        getUserClaimInvestmentDetails ( userClaimInvestmentInput : { poolId: $poolId }) {
            amount,
            receivingAddress,
            totalTokenEarned,
            totalTokenClaimable,
            distributionScAddress {
                networkId,
                token,
                address
            },
            merkleProof {
                root,
                leaf,
                proof,
            },
        }
    }
`

export default GET_USER_CLAIM_INVESTMENT_DETAILS;